<template>
  <div>
    <!-- banner -->
    <!-- banner -->
    <div class="card">
      <template v-if="banners.ContactPage">
        <img class="w-100 h-25" :src="banners.ContactPage[0].bannerUrl" alt />
      </template>
      <img class="w-100 h-25" src="@/static/banner/b-news.png" alt />
    </div>

    <!-- 联系我们 -->
    <div class="container">
      <big-title title="联系我们" English="CONTACT US"></big-title>

      <div class="item-text text-center mt-4 mb-2"></div>

      <div class="d-flex justify-content-center">
        <div class="map w-75">
          <img class="w-100" src="@/static/map.png" alt />
        </div>
        <div
          class="w-100 flex-lg-fill d-flex flex-column justify-content-center align-items-center"
        >
          <h4 class="title text-center">深圳市前海峻荣商业保理有限公司</h4>
          <img class="w-45" src="@/static/er-wei-ma.jpg" alt />
          <div class="w-100 ml-5">
            <div class="item">
              地址：深圳市福田区福田街道福南社区深南中路3039号国际文化大厦1322-1325
            </div>
            <div class="item">联系电话：0755-83218845</div>
            <div class="item">网址：www.jrbaoli.com</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bigTitle from "@/components/big-title.vue";
import banners from "@/mixins/banners.js";
export default {
  mixins: [banners],
  components: {
    bigTitle,
  },
};
</script>


<style lang="less" scoped>
.item-text {
  color: #999;
  font-size: 0.8rem;
}
.item {
  // color: #999;
  font-size: 1rem;
}
.w-45 {
  width: 40%;
}
</style>


// WEBPACK FOOTER //
// src/view/contact.vue